import { Spinner } from '@astral/ui';
import { useT } from '../../providers/I18nProvider.js';

/** Shown while the session is being established. */
export function SplashScreen(): JSX.Element {
  const t = useT();
  return (
    <div className="status-screen">
      <div className="status-screen__logo">✦</div>
      <div className="status-screen__title">{t('common.appName')}</div>
      <Spinner size={26} />
      <div className="status-screen__text muted">{t('auth.signingIn')}</div>
    </div>
  );
}
